import { http } from '../services';

class ProjetosNotaFinalService {
    projetosNotaFinalForm() {
        return http.get('/projetosnotafinal/form');
    }

    getNotadoProjeto(projeto) {
        return http.get(`/projetosnotafinal/${projeto}`);
    }

    async getNotasApresentacaoAvaliador(subevento, area, tipoApresentacao) {
        console.log(tipoApresentacao);
        return http.get('/notas-apresentacao-avaliador', {
            subevento,
            area,
            tipoApresentacao,
        });
    }

    async getProjetosAprovados(evento, subevento, area) {
        return http.get('/projetos-aprovados', {
            evento,
            subevento,
            area,
        });
    }

    async getProjetosAprovadosParaConfirmarApresentacao(area) {
        return http.get('/projetos-aprovados-para-confirmar-apresentacao', {
            area,
        });
    }

    delete(projeto, tipo) {
        return http.delete('/notas-apresentacao', {
            projeto,
            tipo,
        });
    }

    save(nota, projeto, tipo) {
        return http.post('/notas-apresentacao', {
            nota,
            projeto,
            tipo,
        });
    }

    saveMediaAvaliadores(subevento) {
        return http.post('/notas-media-avaliadores', {
            subevento,
        });
    }
}

const projetosNotaFinalService = new ProjetosNotaFinalService();
export default projetosNotaFinalService;
